import React, { useEffect, useState } from 'react';
import { Chip, TextField, Box, Button } from '@mui/material';

type Props = {
  onValueChange: (val: string[]) => void
}
const LabelInput = ({ onValueChange }: Props) => {
  const [chips, setChips] = useState<string[]>([]);
  const [inputValue, setInputValue] = useState('');

  const handleAddChip = () => {
    if (inputValue) {
      setChips([...chips, inputValue]);
      setInputValue('');
    }
  };

  useEffect(() => {
    onValueChange(chips)
  }, [chips])

  const handleDeleteChip = (chipToDelete) => () => {
    setChips((chips) => chips.filter((chip) => chip !== chipToDelete));
  };

  return (
    <Box>
      <Box sx={{ display: 'flex' }}>
        <TextField
          label="Labels"
          variant="outlined"
          value={inputValue}
          fullWidth
          onChange={(e) => setInputValue(e.target.value)}
        />
        <Button onClick={handleAddChip} variant='contained'>Add</Button>
      </Box>
      <Box mt={2}>
        {chips.map((chip) => (
          <Chip
            key={chip}
            label={chip}
            onDelete={handleDeleteChip(chip)}
            style={{ margin: '2px' }}
          />
        ))}
      </Box>
    </Box>
  );
};

export default LabelInput;